import listActions from 'src/modules/respuesta/list/respuestaListActions';
import RespuestaService from 'src/modules/respuesta/respuestaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'RESPUESTA_DESTROY';

const respuestaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: respuestaDestroyActions.DESTROY_STARTED,
      });

      await RespuestaService.destroyAll([id]);

      dispatch({
        type: respuestaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.respuesta.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/respuesta');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: respuestaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: respuestaDestroyActions.DESTROY_ALL_STARTED,
      });

      await RespuestaService.destroyAll(ids);

      dispatch({
        type: respuestaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.respuesta.destroyAll.success'),
      );

      getHistory().push('/respuesta');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: respuestaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default respuestaDestroyActions;
